import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import type { CommunicationsRouteFactory } from "./communicationsRouteContext";

const MessagingListScreen = lazyRouteComponent(
  () => import("../MessagingListScreen"),
  "MessagingListScreen",
);

export const createMessagingRoutes: CommunicationsRouteFactory = ({
  context,
}) => [
  createRoute({
    getParentRoute: context.getParentRoute,
    path: `${context.basePath}/messages`,
    component: MessagingListScreen,
  }),
];
